import { render, staticRenderFns } from "./CodAdvanceAlertBell.vue?vue&type=template&id=3b66b338&scoped=true"
import script from "./CodAdvanceAlertBell.vue?vue&type=script&lang=js"
export * from "./CodAdvanceAlertBell.vue?vue&type=script&lang=js"
import style0 from "./CodAdvanceAlertBell.vue?vue&type=style&index=0&id=3b66b338&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b66b338",
  null
  
)

export default component.exports